import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import MUIDataTable from 'mui-datatables';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import * as Yup from 'yup';

import { CircularProgress } from '@material-ui/core';
import DebounceTableSearch from './DebounceTableSearch';
import CSVDownload from './CSVDownload';
import ResetTable from './ResetTable';
import { Button, ModalBody, ModalMenus } from './styles';
import ButtonForm from '~/components/Form/Button';
import Modal from '~/components/Modal';
import Select from '~/components/Form/Select'
import Textarea from '~/components/Form/Textarea'
import { toast } from 'react-toastify';
import { Form } from '@unform/web';
import { useSelector } from 'react-redux';


export default function Table({
  data,
  page,
  perPage,
  total,
  pagination,
  editPerPege,
  search,
  loading,
  handleExportCSV,
  columns,
  handleFilterSubmit,
  editar,
  reset,
  handleUserTransfer,
  users
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [userTransfer, setUserTransfer] = useState(0)
  const [idDatasState, setIdDatasState] = useState([])
  const user = useSelector(state => state.user.profile)
  const inputRef = useRef(null)

  async function handleIdDatas(idDatas) {
    if (user.provider === '3') {
      toast.error('Apenas gerentes e diretores podem realizar essa ação!')
      reset()
      return
    }

    setIdDatasState(idDatas)
    setIsVisible(true)
  }

  async function handleSubmit(data) {
    try {
      const schema = Yup.object().shape({
        user_id: Yup.string(
          'Selecione um usário.'
        ).required('Selecione um usuário'),
        motivo: Yup.string(
          'Informe o motivo da tranferência'
        ).required('Informe o motivo da tranferência')
      });
  
      console.log('DATA', data)
  
      await schema.validate(data, {
        abortEarly: false
      })
  
      setIsVisible(false)
      handleUserTransfer(idDatasState, userTransfer, data.motivo)
    } catch (err) {
      const validationErrors = {}
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
          console.log(validationErrors)
        });
        inputRef.current.setErrors(validationErrors);
      }
    }
  }


  const estilos = createTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: '#2a3142',
        },
        paper: {
          backgroundColor: '#2a3142',
          width: '100%',
          maxWidth: '100%',
        },
      },
      MUIDataTableHeadCell: {
        root: {
          backgroundColor: '#2a3142',
        },
      },
      MUIDataTableFilter: {
        root: {
          backgroundColor: '#2A3142',
          width: '500px',
        },
        title: {
          color: '#FFFFFF',
        },
      },
      MuiButton: {
        label: {
          color: '#FFFFFF',
        },
      },
      MuiGridList: {
        root: {
          color: '#FFFFFF',
        },
      },
      MuiTableCell: {
        root: {
          cursor: !editar ? 'default' : 'pointer',
        },
      },
      MuiInputLabel: {
        root: {
          color: '#FFFFFF',
        },
      },
      MuiFormLabel: {
        root: {
          color: '#FFFFFF',
        },
      },
    },
  });

  function handleReset() {
    reset();
  }

  const optionsTable = {
    filter: true,
    fixedHeader: true,
    filterType: "dropdown",
    responsive: 'scrollMaxHeight',
    selectToolbarPlacement: "none",
    selectableRows: "multiple", // Enable selection of multiple rows
    search: false,
    searchOpen: false,
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          padding: ".5rem",
          margin: ".5rem auto"
        }
      };
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      const idDatas = selectedRows.data.map(selectedRow => {
        return displayData.filter(rowData => rowData.dataIndex === selectedRow.dataIndex)[0].data[0]
      })

      return (
        <>
          {isVisible && (
            <Modal>
              <ModalBody>
                <span id="title">Esta ação será irreversível!</span>
                <span id ="title">Para qual usuário deseja transferir ?</span>
                <Form ref={inputRef} onSubmit={handleSubmit}>
                  <Select
                    name="user_id"
                    labelSelect="Selecione o usuário"
                    options={users}
                    onChange={(e) => setUserTransfer(e.value)}
                  />
                  <Textarea
                    style={{ minHeight: '100px' }}
                    name="motivo" label="Informe o motivo"
                  />
                  <ModalMenus>
                    <button type="button" onClick={() => setIsVisible(false)}>
                      Cancelar
                    </button>
                    <ButtonForm>
                      Transferir
                    </ButtonForm>
                  </ModalMenus>
                </Form>
              </ModalBody>
            </Modal>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '20px' }}>
            <Button onClick={() => handleIdDatas(idDatas)}>Transferir Leads</Button>
            <span>(Limite de 100 leads por transferência)</span>
          </div>
        </>
      )
    },
    page: page - 1,
    count: total,
    rowsPerPage: perPage,
    rowsPerPageOptions: [100, 150, 200],
    rowHover: true,
    serverSide: true,
    print: false,
    download: false,
    textLabels: {
      body: {
        noMatch: loading ? 'Carregando' : 'Desculpe, não possui nenhum dado',
        toolTip: 'Ordenar',
      },
      pagination: {
        next: 'Proxima',
        previous: 'Anterior',
        rowsPerPage: 'Dados por página:',
        displayRows: 'de',
      },
      toolbar: {
        search: 'Pesquisar',
        downloadCsv: 'Download CSV',
        print: 'Imprimir',
        viewColumns: 'Ver Colunas',
        filterTable: 'Filtrar tabela',
      },
      filter: {
        all: 'Todos',
        title: 'Filtros',
        reset: 'Resetar',
      },
      selectedRows: {
        text: 'Dado(s) selecionado',
        delete: 'Deletar',
        deleteAria: 'Deletar dados selecionados',
      },
    },
    customToolbar: () => (
      <>
        {/* <CSVDownload handleClick={handleExportCSV} /> */}
        <ResetTable handleClick={handleReset} />
      </>
    ),
    customSearchRender: (searchText, handleSearch, hideSearch, options) => {
      return (
        <DebounceTableSearch
          searchText={searchText}
          onSearch={handleSearch}
          onHide={hideSearch}
          options={options}
        />
      );
    },
    onChangePage: number => {
      pagination(number + 1);
    },
    onChangeRowsPerPage: number => {
      editPerPege(number);
    },
    onSearchChange: value => {
      search(value);
    },
    customFilterDialogFooter: (curentFilterList, applyFilters) => {
      const filters = curentFilterList.map((element, index) => {
        return {
          column: columns[index].label.toLowerCase(),
          filter: element[0]
        }
      }).filter((item) => item.filter !== undefined)


      return (
        <div style={{ marginTop: '40px' }}>
          <Button onClick={() => handleFilterSubmit(filters)}>
            Aplicar filtro
          </Button>
        </div>
      );
    },
  };

  return (
    <>
      {loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <>
          <MuiThemeProvider theme={estilos}>
            <MUIDataTable
              title="teste"
              data={data}
              columns={columns}
              options={optionsTable}
            />
          </MuiThemeProvider>
        </>
      )}
    </>
  );
}

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  pagination: PropTypes.func.isRequired,
  editPerPege: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  handleExportCSV: PropTypes.func.isRequired,
  handleFilterSubmit: PropTypes.func.isRequired,
  editar: PropTypes.func,
};

Table.defaultProps = {
  editar: null,
};
